import { Metamodel } from './model';
import { A365DummyNamed } from './a365DummyNamed';

/**
 * This A365 Named class is used to model resources that cannot be published, and cannot be dirty
 * and displayed in the shell object explorer such as storage file system.
 */
@Metamodel.model({
    name: 'immutableA365Named',
    display: ['immutable A365 resource'],
    reusable: true,
    referable: true
})
export class ImmutableA365Named extends A365DummyNamed {
}
